import React, { useEffect } from 'react';
import { ChildrenPropType } from '../../prop-types/children';
import { useSelectedOrdersViewId } from './orders-left-nav/orders-left-nav-context';
import { useDispatch } from 'react-redux';
import { clearDrawerOrders } from '../../store/orders/drawer/orders.drawer.actions';
import { autoSwitchFilterViewToDefault } from '../../store/orders/filtering/orders.filtering.actions';
import { getOrderStatusFromViewName } from '../../services/sales-order-service';
import * as OrdersActions from '../../store/orders/orders.actions';
import { clearSelectedShipments } from '../../store/shipments/selected-shipments/shipments.selected-shipments.actions';
import { clearSelectedOrders } from '../../store/orders/selected-orders/orders.selected-orders.actions';
import { setSelectedReturns } from '../../store/returns/selected-returns/returns.selected-returns.actions';

const viewsThatDoNotGetOrders = ['alerts', 'shiptogether', 'advanced-search'];
const requestGetOrders = (viewId) => {
  if (viewsThatDoNotGetOrders.includes(viewId)) {
    return;
  }
  const orderStatus = getOrderStatusFromViewName(viewId);
  if (!orderStatus) {
    return OrdersActions.getOrdersCounts();
  }
  return OrdersActions.requestGetOrders();
};

export const OrdersPageStateManager = ({ children }) => {
  const dispatch = useDispatch();
  const selectedViewId = useSelectedOrdersViewId();
  useEffect(() => {
    dispatch(clearDrawerOrders());
    dispatch(autoSwitchFilterViewToDefault());
    dispatch(clearSelectedShipments());
    dispatch(clearSelectedOrders());
    dispatch(setSelectedReturns([]));
    const requestAction = requestGetOrders(selectedViewId);
    if (!requestAction) {
      return;
    }
    dispatch(requestAction);
  }, [selectedViewId, dispatch]);

  return <>{children}</>;
};

OrdersPageStateManager.propTypes = {
  children: ChildrenPropType.isRequired,
};
